import { NodeProps } from '@xyflow/react';
import BaseNode from './baseNode';
import { AgentNodeType } from './nodesUtils';

const AgentNode = (node: NodeProps<AgentNodeType>) => {
  return (
    <BaseNode
      node={node}
      icon={node.data.entity?.agentDef?.instanceIcon || 'screwdriver-wrench'}
      label={node.data.entity.agentDef?.name || 'Agent'}
      canDelete={true}
    />
  );
};

export default AgentNode;
